import { ReactComponent as GlobeSvg } from "../../assets/thingsYouDontWantToMiss/globe.svg";
import { ReactComponent as PersonalComputerSvg } from "../../assets/thingsYouDontWantToMiss/personal-computer.svg";
import { ReactComponent as SliceOfPizza } from "../../assets/thingsYouDontWantToMiss/slice-of-pizza.svg";
import { ReactComponent as ToolsSvg } from "../../assets/thingsYouDontWantToMiss/tools.svg";

const thingsYouDontWantToMissData = [
  {
    id: 1,
    title: "Technical Content",
    svg: <PersonalComputerSvg></PersonalComputerSvg>,
    text: `Dive into a world of innovation with Google Developer Student Club at SZABIST Karachi. Get access to top-notch technical content, expert sessions, and resources to keep you ahead in the tech space.`,
  },
  {
    id: 2,
    title: "Workshops",
    svg: <ToolsSvg></ToolsSvg>,
    text: `Join engaging workshops and codelabs designed to give you hands-on experience with cutting-edge technologies. A great way to start your journey and build real-world projects.`,
  },
  {
    id: 3,
    title: "Networking",
    svg: <GlobeSvg></GlobeSvg>,
    text: `Connect with peers, mentors, and industry leaders to collaborate, learn, and grow. Build a strong network that can open doors to exciting opportunities.`,
  },
  {
    id: 4,
    title: "Skill Building",
    svg: <SliceOfPizza></SliceOfPizza>,
    text: `Refine your skills with activities that focus on both technical expertise and personal development. Make every session count towards a brighter future.`,
  }
  
];

export default thingsYouDontWantToMissData;
